import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import colors from './colors.module.scss';
import legacyColors from './legacyColors.module.scss';
import shapes from './shapes.module.scss';
import css from './index.module.scss';
import { ChartingLegacyColor } from './types';

type ColorClasses = keyof typeof colors;
type StripedClasses = `${ColorClasses}-striped`;

type ColorOptions = {
  [P in ColorClasses]: P extends StripedClasses ? never : P;
}[ColorClasses];

export interface ChartingShapeProps {
  color: ColorOptions;
  shape: keyof typeof shapes;
  striped?: boolean;
  legacyColorOverride?: ChartingLegacyColor;
  gradient?: boolean;
}

export const ChartingShape = ({
  color,
  shape,
  striped = false,
  legacyColorOverride,
  gradient = false,
}: ChartingShapeProps) => {
  let colorClassName = '';
  if (!gradient) {
    if (legacyColorOverride !== undefined) {
      colorClassName = legacyColors[legacyColorOverride];
    } else if (
      striped &&
      color &&
      color !== 'neutral-50-opacity-24' &&
      color !== 'purple-60-opacity-24'
    )
      colorClassName = colors[`${color}-striped` as const];
    else {
      colorClassName = colors[color];
    }
  }
  return (
    <div
      data-testid="ChartingShape"
      data-component="ChartingShape"
      className={classNames(shapes[shape], colorClassName, { [css.gradient]: gradient })}
    />
  );
};
